var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-lg": "" } },
    [
      _vm.loadingCategories
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            _vm._l(3, function(n) {
              return _c(
                "v-flex",
                { key: n, attrs: { xs12: "", sm6: "", lg3: "" } },
                [_c("v-skeleton-loader", { attrs: { type: "card" } })],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "v-layout",
        {
          staticClass: "category-products mb-10 justify-center",
          attrs: { row: "", wrap: "" }
        },
        _vm._l(_vm.allProducts, function(product) {
          return _c(
            "v-flex",
            { key: product.id, attrs: { xs12: "", sm6: "", md3: "", lg3: "" } },
            [
              _c(
                "v-card",
                { staticClass: "text-center transparent", attrs: { flat: "" } },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "product-title mb-2",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/product/" + product.alias)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(product.name) + " ")]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "v-img",
                        {
                          staticClass: "cursor-pointer",
                          attrs: { src: _vm.getProductImage(product.imageUrl) },
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/product/" + product.alias
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center",
                              staticStyle: { width: "51%", "margin-top": "5%" }
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass: "white--text",
                                  style: _vm.fontHeight
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("homepage.currency", {
                                          price: _vm.formatThousands(
                                            product.amountWithVat
                                          )
                                        })
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-lowercase text-center white--text",
                              staticStyle: {
                                position: "absolute",
                                bottom: "0px",
                                "margin-left": "2px",
                                "margin-right": "2px",
                                "margin-bottom": "8px",
                                width: "50%"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  style: {
                                    "font-size": _vm.fontHeightCart,
                                    "line-height": _vm.fontHeightCart
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "vertical-align": "middle"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("cart.addToCart")))]
                                  ),
                                  _c("img", {
                                    staticClass: "cart-image ml-1",
                                    style: {
                                      height: _vm.fontHeightCart,
                                      "line-height": _vm.fontHeightCart
                                    },
                                    attrs: {
                                      src: require("../../assets/shoping_bag_white.svg")
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-card-text", {
                    staticClass: "pt-0 px-0 text-center cart-button-wrapper"
                  }),
                  _c("v-card-text", { staticClass: "description pt-0" }, [
                    _c("strong", {
                      domProps: { innerHTML: _vm._s(product.shortDescription) }
                    }),
                    product.inStock
                      ? _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("product.inStock", {
                                inStock: _vm.formatThousands(product.inStock)
                              })
                            )
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }